import React, { useState, useEffect} from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import Episode from './Episode';
import TrackData from './TrackData';
// import _ from 'lodash'
import {
  onAirFM as getONAirFM, onAirZD, programEpisodeWithPlaylist, fetchProgramIfNeeded
} from '~/programs/actions'
import OnAirProgram from '~/programs/components/OnAirProgram';
import { DateTime } from 'luxon';

const SoundsLike = (props) => {

  const [ shows, setShows ] = useState([])

  const getNP = () => {
    const { dispatch } = props;
    dispatch(getONAirFM())
    dispatch(onAirZD())
  }

  useEffect(() => {
    var timeout = null;
    const { dispatch, programs, programsFM, onAirFM } = props;
    getNP();
    timeout = setInterval(getNP, 600000);
    const soundsLike = { url:null,
      guideUrlOverride:null,
      name: "Sounds Like Community Radio",
      broadcasters: null,
      defaultFirstAiredGuide:"fm",
      slug: "sounds-like-community-radio",
      start: "14:00:00",
      onairnow: true
    }
		dispatch(fetchProgramIfNeeded(soundsLike.slug))
    if(onAirFM.key && programsFM.items.length) {
      let shows = [

        {...soundsLike, title: 'RECORDED LIVE AT 4ZZZ', reverse: true, height: '95vh'}
      ]
      let datestring = '2022-09-06'

      shows.map((item) => {
        if (! programs[item.slug]) {
          dispatch(programEpisodeWithPlaylist(item.slug, datestring))
        }
      })
      setShows(shows);
    }
    
    return () => {
      clearInterval(timeout);
    }
  }, [] )


  const { programs, programsFM, onAirFM } = props
  const showsGuide = shows.map((item, index) => {
    var episode, playlist
    let nowDate = DateTime.local().setZone("Australia/Brisbane").toISODate()

    if ( programs && programs[item.slug] && programs[item.slug].episodes && programs[item.slug].episodes.episodeIndex) {

      return programs[item.slug].episodes.episodeIndex.filter(i => i === '2022-09-06 14:00:00').map((i,n) => <div key={n}>
        <OnAirProgram onairnow={true} program={item} episode={programs[item.slug].episodes[i]} playlist={playlist} title={item.title} height={item.height} reverse={item.reverse}/>
      </div>)
    }
    else {
      return null
    }
  })

  return (
    <div>
      {showsGuide}
    </div>
  )
  
}

SoundsLike.fetchData = (store)  => {
  return Promise.all([
    store.dispatch(fetchProgramIfNeeded('sounds-like-community-radio')),
    store.dispatch(programEpisodeWithPlaylist('sounds-like-community-radio', '2022-09-06'))
  ]).then( () => {
    console.log('sounds like fetched')
  })
}

export default connect(state => ({programs: state.programs, programsFM: state.programsFM, onAirFM: state.onAirFM})) (SoundsLike)
